import { v4 as uuidv4 } from 'uuid';

const getUuid = () => {
    return uuidv4();
}

export default getUuid;



// WEBPACK FOOTER //
// ./src/utils/getUuid.js